/**
 * Customer Reviews V2 Slider Component
 */
(function() {
  'use strict';

  const whenVisible = window.theme?.whenVisible || ((element, callback) => callback(element));

  function initReviewV2Sliders(container) {
    const sections = (container.classList && container.classList.contains('reviews-v2-section'))
      ? [container]
      : container.querySelectorAll('.reviews-v2-section');

    sections.forEach(function(section) {
      const swiperElement = section.querySelector('.swiper');
      if (!swiperElement || section.swiperInstance) return;

      window.loadThemeSwiper().then(() => {
        initSwiper(section, swiperElement);
      }).catch((error) => {
        console.warn('Swiper failed to load for CustomerReviewsV2:', error);
      });
    });
  }

  function initSwiper(section, swiperElement) {
    const showArrowsDesktop = section.dataset.showArrowsDesktop === 'true';
    const showArrowsMobile  = section.dataset.showArrowsMobile  === 'true';
    const isMobile = window.innerWidth < 750;
    const showNavigation = isMobile ? showArrowsMobile : showArrowsDesktop;

    const config = {
      slidesPerView: parseInt(section.dataset.slidesDesktop) || 3,
      spaceBetween: parseInt(section.dataset.spaceBetween) || 30,
      loop: section.dataset.loop === 'true',
      autoplay: section.dataset.autoplay === 'true' ? {
        delay: parseInt(section.dataset.autoplayDelay) || 4000,
        disableOnInteraction: false,
      } : false,
      pagination: section.dataset.showPagination === 'true' ? {
        el: section.querySelector('.swiper-pagination'),
        clickable: true,
      } : false,
      navigation: showNavigation ? {
        nextEl: section.querySelector('.reviews-v2-section__nav-btn--next'),
        prevEl: section.querySelector('.reviews-v2-section__nav-btn--prev'),
      } : false,
      breakpoints: {
        320: {
          slidesPerView: parseInt(section.dataset.slidesMobile) || 1,
          spaceBetween: parseInt(section.dataset.spaceBetweenMobile) || 20,
        },
        576: {
          slidesPerView: parseInt(section.dataset.slidesTablet) || 2,
          spaceBetween: parseInt(section.dataset.spaceBetween) || 20,
        },
        992: {
          slidesPerView: parseInt(section.dataset.slidesDesktop) || 3,
          spaceBetween: parseInt(section.dataset.spaceBetween) || 30,
        },
      },
    };

    section.swiperInstance = new Swiper(swiperElement, config);
  }

  if (!customElements.get('customer-reviews-v2-section')) {
    class CustomerReviewsV2Section extends HTMLElement {
      connectedCallback() {
        this.visibilityObserver = whenVisible(this, () => initReviewV2Sliders(this));
      }

      disconnectedCallback() {
        this.visibilityObserver?.disconnect?.();
        this.swiperInstance?.destroy(true, true);
        this.swiperInstance = null;
      }
    }
    customElements.define('customer-reviews-v2-section', CustomerReviewsV2Section);
  }
})();
